<template>
  <div class="w-screen max-w-[620px] mx-auto h-screen">
    <router-view v-slot="{ Component }">
      <transition
        name="scale"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { resolveAppTypeFromQuery, setAppType } from '@/comp/AppType'

const route = useRoute()

const loadAppType = () => {
  try {
    const queryAppType = resolveAppTypeFromQuery(route.query)
    if (queryAppType) {
      setAppType(queryAppType)
    }
  } catch (e) {
    console.error('Error loading app type', e)
  }
}

watch(() => route.query, loadAppType, { immediate: true })
</script>
